import amplifyConfig from '~/plugins/cognito';
import kpwebFetch from '~/plugins/customFetch';
import can from '~/plugins/permissions';
import dayjs from '~/plugins/dayjs';
import { i18n } from '~/plugins/i18n';
import vuetify from '~/plugins/vuetify';

export default {
  install(app) {
    app.use(amplifyConfig);
    app.use(can);
    app.use(dayjs);
    app.use(kpwebFetch);
    app.use(i18n);
    app.use(vuetify);
  },
};
